<app-header headerText="Registro Ahorro Por Acciones"></app-header>

<mat-tab-group mat-align-tabs="center" animationDuration="0ms" dynamicHeight=true>

  <mat-tab>
    <ng-template mat-tab-label>
      <mat-icon>unarchive</mat-icon>
      Carga de <br>Colaboradores
    </ng-template>

    <div class="row p-4 ml-4" *ngIf="!employeeFile; else fileResult">

      <div class="col-sm-12 col-md-3 py-4 text-center">
        <button class="btn-block pt-3" mat-stroked-button color="primary" (click)="createTemplateFile()">
          <img class="img-responsive center-block" src="{{plantilla}}" /><br>
          <label> Descargar Plantilla </label>
        </button>
      </div>

      <div class="col-sm-12 col-md-1 text-center arrow-center">
        <i class="material-icons align-middle"> double_arrow </i>
      </div>

      <!--div class="col-sm-12 col-md-3 text-center">
        <input type="checkbox" checked data-toggle="toggle" 
        data-on="Ready" data-off="Not Ready" data-onstyle="success"
          data-offstyle="danger">
        </div-->

        <div class="col-sm-12 col-md-3 py-4 text-center div-center">
          <mat-button-toggle-group class= "div-center" #group="matButtonToggleGroup" value="{{saveAction}}">
            <mat-button-toggle value="add"  (change)="typeUpload($event.value)">
              <button mat-button color="primary" style="pointer-events:none;">
                <mat-icon>library_add</mat-icon>
                <label class="pl-2">Agregar Colaboradores</label>
              </button>
            </mat-button-toggle>
            <mat-button-toggle value="new" (change)="typeUpload($event.value)">
              <button mat-button class="success" style="pointer-events:none;">
                <mat-icon>library_books</mat-icon>
                <label class="pl-2">Nueva Lista Colaboradores</label>
              </button>
            </mat-button-toggle>
          </mat-button-toggle-group>
          <div class="my-4 py-2">
            <div class="example-selected-value">{{textAction}}</div>
          </div>


        </div>


      

      <div class="col-sm-12 col-md-1 text-center arrow-center">
        <i class="material-icons align-middle"> double_arrow </i>
      </div>

      <div class="col-sm-12 col-md-3 py-2 text-center">
        <div class="card mt-3">
          <div class="card-content mt-3 text-center">
            <label>Seleccionar archivo de excel. </label>
            <div class="file-upload">
              <label>
                <div class="icon">
                  <i class="material-icons">cloud_upload</i>
                  <input #file (change)="onFileChange($event)" ng-disabled="pageWorking" class="none" type="file"
                    [accept]="fileType" [multiple]="multipleFiles">
                </div>
              </label>
            </div>
            <hr>
            <p class="text-center"> El archivo debe de tener todos los campos. <br>
            </p>
          </div>
        </div>
      </div>

    </div>

    <ng-template #fileResult>
      <div class=" m-2">

        <h5>Registros detectados en el archivo:</h5>

        <table mat-table [dataSource]="selectedFileResults" class="table">

          <ng-container matColumnDef="row">
            <th mat-header-cell *matHeaderCellDef> Fila No. </th>
            <td mat-cell *matCellDef="let element"> {{element.index ? element.index : 0}} </td>
          </ng-container>

          <ng-container matColumnDef="employeeNumber">
            <th mat-header-cell *matHeaderCellDef> Número de Empleado </th>
            <td mat-cell *matCellDef="let element"> {{element.employee.employeeNumber}} </td>
          </ng-container>

          <ng-container matColumnDef="investmentType">
            <th mat-header-cell *matHeaderCellDef> Tipo de Acción </th>
            <td mat-cell *matCellDef="let element"> {{element.employee.investmentType}} </td>
          </ng-container>

          <ng-container matColumnDef="contractNumber">
            <th mat-header-cell *matHeaderCellDef> Num. Contrato </th>
            <td mat-cell *matCellDef="let element"> {{element.employee.contractNumber}} </td>
          </ng-container>

          <ng-container matColumnDef="message">
            <th mat-header-cell *matHeaderCellDef> Descripción </th>
            <td mat-cell *matCellDef="let element">
              {{element.success ? 'Lista para ser creada' : element.message.join(', ')}} </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns; let result"
            [ngClass]="{ 'error-row': result.success == false }"></tr>
        </table>
      </div>

      <div *ngIf="employeeFileHasErrors; else cancelCreateEmployees" class="row justify-content-center">
        <div class="col-5">
          <button class="btn btn-block btn-outline-primary" (click)="saveEmployees()">
            Crear
          </button>
        </div>
        <div class="col-5">
          <button class="btn btn-block btn-outline-danger" (click)="resetEmployees()">
            Cancelar
          </button>
        </div>
      </div>

      <ng-template #cancelCreateEmployees>
        <div class="row justify-content-center">
          <div class="col-10 alert alert-danger text-center" role="alert">
            <b> Ocurrio un Error </b> {{ messageError}}
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-8">
            <button class="btn btn-block btn-outline-danger" (click)="resetEmployees()">
              Regresar
            </button>
          </div>
        </div>

      </ng-template>

    </ng-template>

  </mat-tab>
  <mat-tab>
    <ng-template mat-tab-label>
      <mat-icon>how_to_reg</mat-icon>
      Consultar <br>Colaboradores
    </ng-template>

    <div class="row p-3 justify-content-center">
      <h5 class="my-3">Colaboradores registrados</h5>
    </div>

    <div class="my-5 row">
      <div class="col-md-4 offset-md-4">
        <button class="btn btn-block btn-outline-primary" (click)="descargar()">
          <mat-icon>cloud_download</mat-icon><br>
          Descargar
        </button>
      </div>


    </div>


  </mat-tab>

</mat-tab-group>